export var addUPIDetailsMapper = function (resp) {
    if (resp && resp.data) {
        return {
            data: resp.data,
            upiSuccess: true,
        };
    }
    return {
        data: "",
        upiSuccess: false,
    };
};
